import type { DataSourceListItem } from '../models/DataSource';

/** Credential owners authorize access; folder endpoints are the reusable data sources. */
export function isReusableSourceForFolder(
  source: Pick<DataSourceListItem, 'provider' | 'credentialSourceId'>,
  folderId?: string,
): boolean {
  return !(
    folderId
    && (source.provider === 'google_sheets' || source.provider === 'excel_online')
    && !source.credentialSourceId
  );
}
